import { makeStyles, DialogContent } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(4.5)}px ${theme.spacing(5)}px`,
  }
}))

export const DialogBox = ({ children }) => {
  const classes = useStyles();

  return (
    <DialogContent className={classes.root}>
      {children}
    </DialogContent>
  )
}
